//Quick View

$(document).ready(function () {
  $.getScript(
    "//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js"
  ).done(function () {
    quickView();
  });
});

function quickView() {
  $(".quick-view").click(function () {
    if ($("#quick-view").length == 0) {
      $("body").append('<div id="quick-view"></div>');
    }

    var product_handle = $(this).data("handle");

    $("#quick-view").addClass(product_handle);

    jQuery.getJSON("/products/" + product_handle + ".js", function (product) {
      var title = product.title;

      var type = product.type;

      var price = 0;

      var original_price = 0;

      var desc = product.description;

      var images = product.images;

      var variants = product.variants;

      var options = product.options;

      var url = "/products/" + product_handle;

      $(".qv-product-title").text(title);

      $(".qv-product-type").text(type);

      $(".qv-product-description").html(desc);

      $(".view-product").attr("href", url);

      var imageCount = $(images).length;

      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';

          image_embed = image_embed
            .replace(".jpg", "_800x.jpg")
            .replace(".png", "_800x.png");

          $(".qv-product-images").append(image_embed);

          $(".qv-product-images")
            .slick({
              dots: false,

              arrows: false,

              respondTo: "min",

              useTransform: false,
            })
            .css("opacity", "1");
        } else {
          image_embed = '<div><img src="' + image + '"></div>';

          image_embed = image_embed
            .replace(".jpg", "_800x.jpg")
            .replace(".png", "_800x.png");

          $(".qv-product-images").append(image_embed);
        }
      });

      $(options).each(function (i, option) {
        var opt = option.name;

        var selectClass = ".option." + opt.toLowerCase();

        $(".qv-product-options").append(
          '<div class="option-selection-' +
            opt.toLowerCase() +
            '"><span class="option">' +
            opt +
            '</span><select class="option-' +
            i +
            " option " +
            opt.toLowerCase() +
            '"></select></div>'
        );

        $(option.values).each(function (i, value) {
          $(".option." + opt.toLowerCase()).append(
            '<option value="' + value + '">' + value + "</option>"
          );
        });
      });

      $(product.variants).each(function (i, v) {
        if (v.inventory_quantity == 0) {
          $(".qv-add-button").prop("disabled", true).val("Sold Out");

          $(".qv-add-to-cart").hide();

          $(".qv-product-price").text("Sold Out").show();

          return true;
        } else {
          price = parseFloat(v.price / 100).toFixed(2);

          original_price = parseFloat(v.compare_at_price / 100).toFixed(2);

          $(".qv-product-price").text("$" + price);

          if (original_price > 0) {
            $(".qv-product-original-price")
              .text("$" + original_price)
              .show();
          } else {
            $(".qv-product-original-price").hide();
          }

          $("select.option-0").val(v.option1);

          $("select.option-1").val(v.option2);

          $("select.option-2").val(v.option3);

          return false;
        }
      });

      $("#List_1 a").click(function (ev) {
        $("#selected_opt_1").html($(this).html());
        var addColor_1 = $(this)
          .children("#List_1 a span")
          .css("background-color");
        $("#selected_opt_1 span").css("background-color", addColor_1);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color1").val(getVal);
        $("#alert1").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_2 a").click(function (ev) {
        $("#selected_opt_2").html($(this).html());

        var addColor_2 = $(this)
          .children("#List_2 a span")
          .css("background-color");
        $("#selected_opt_2 span").css("background-color", addColor_2);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color2").val(getVal);
        $("#alert2").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_3 a").click(function (ev) {
        $("#selected_opt_3").html($(this).html());

        var addColor_3 = $(this)
          .children("#List_3 a span")
          .css("background-color");
        $("#selected_opt_3 span").css("background-color", addColor_3);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color3").val(getVal);
        $("#alert3").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_4 a").click(function (ev) {
        $("#selected_opt_4").html($(this).html());
        var addColor_4 = $(this)
          .children("#List_4 a span")
          .css("background-color");
        $("#selected_opt_4 span").css("background-color", addColor_4);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color4").val(getVal);
        $("#alert4").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_5 a").click(function (ev) {
        $("#selected_opt_5").html($(this).html());
        var addColor_5 = $(this)
          .children("#List_5 a span")
          .css("background-color");
        $("#selected_opt_5 span").css("background-color", addColor_5);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color5").val(getVal);
        $("#alert5").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_6 a").click(function (ev) {
        $("#selected_opt_6").html($(this).html());
        var addColor_6 = $(this)
          .children("#List_6 a span")
          .css("background-color");
        $("#selected_opt_6 span").css("background-color", addColor_6);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color6").val(getVal);
        $("#alert6").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_7 a").click(function (ev) {
        $("#selected_opt_7").html($(this).html());
        var addColor_7 = $(this)
          .children("#List_7 a span")
          .css("background-color");
        $("#selected_opt_7 span").css("background-color", addColor_7);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color7").val(getVal);
        $("#alert7").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_8 a").click(function (ev) {
        $("#selected_opt_8").html($(this).html());
        var addColor_8 = $(this)
          .children("#List_8 a span")
          .css("background-color");
        $("#selected_opt_8 span").css("background-color", addColor_8);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color8").val(getVal);
        $("#alert8").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_9 a").click(function (ev) {
        $("#selected_opt_9").html($(this).html());
        var addColor_9 = $(this)
          .children("#List_9 a span")
          .css("background-color");
        $("#selected_opt_9 span").css("background-color", addColor_9);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color9").val(getVal);
        $("#alert9").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_10 a").click(function (ev) {
        $("#selected_opt_10").html($(this).html());
        var addColor_10 = $(this)
          .children("#List_10 a span")
          .css("background-color");
        $("#selected_opt_10 span").css("background-color", addColor_10);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color10").val(getVal);
        $("#alert10").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_11 a").click(function (ev) {
        $("#selected_opt_11").html($(this).html());
        var addColor_11 = $(this)
          .children("#List_11 a span")
          .css("background-color");
        $("#selected_opt_11 span").css("background-color", addColor_11);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color11").val(getVal);
        $("#alert11").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_12 a").click(function (ev) {
        $("#selected_opt_12").html($(this).html());
        var addColor_12 = $(this)
          .children("#List_12 a span")
          .css("background-color");
        $("#selected_opt_12 span").css("background-color", addColor_12);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color12").val(getVal);
        $("#alert12").removeClass("alert");
        ev.preventDefault();
      });

      if (
        product_handle.includes("first-dip-set") ||
        product_handle.includes("powder-remover-gel")
      ) {
        $(".selection_sec_4_color").remove();
        $(".selection_sec_5_color").remove();
        $(".selection_sec_6_color").remove();
        $(".selection_sec_10_color").remove();
        $(".selection_sec_12_color").remove();

        $("#dropdown-wrapper_1").click(function (ev) {
          $(this).toggleClass("is-active");
        });

        $("#List_1 a").click(function (ev) {
          $("#selected_opt_1").html($(this).html());
          var addColor_1 = $(this)
            .children("#List_1 a span")
            .css("background-color");
          $("#selected_opt_1 span").css("background-color", addColor_1);
          let getVal = $(this).text();
          console.log(getVal);
          $("#color1").val(getVal);
          $("#alert1").removeClass("alert");
          ev.preventDefault();
        });
      } else if (
        product_handle.includes("beautiful-nightmare-dipping-set") ||
        product_handle.includes("trio-dip-set") ||
        product_handle.includes("healthy-nail-growth-kit")
      ) {
        $(".selection_sec_1_color").remove();
        $(".selection_sec_5_color").remove();
        $(".selection_sec_6_color").remove();
        $(".selection_sec_10_color").remove();
        $(".selection_sec_12_color").remove();

        $("#dropdown-wrapper_1").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_2").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_3").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        

      $("#List_1 a").click(function (ev) {
        $("#selected_opt_1").html($(this).html());
        var addColor_1 = $(this)
          .children("#List_1 a span")
          .css("background-color");
        $("#selected_opt_1 span").css("background-color", addColor_1);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color1").val(getVal);
        $("#alert1").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_2 a").click(function (ev) {
        $("#selected_opt_2").html($(this).html());

        var addColor_2 = $(this)
          .children("#List_2 a span")
          .css("background-color");
        $("#selected_opt_2 span").css("background-color", addColor_2);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color2").val(getVal);
        $("#alert2").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_3 a").click(function (ev) {
        $("#selected_opt_3").html($(this).html());

        var addColor_3 = $(this)
          .children("#List_3 a span")
          .css("background-color");
        $("#selected_opt_3 span").css("background-color", addColor_3);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color3").val(getVal);
        $("#alert3").removeClass("alert");
        ev.preventDefault();
      });
        
      } else if (
        product_handle.includes("5-dip-powder-bundle") ||
        product_handle.includes("sweet-dreams-dipping-kit")
      ) {
        $(".selection_sec_1_color").remove();
        $(".selection_sec_4_color").remove();
        $(".selection_sec_6_color").remove();
        $(".selection_sec_10_color").remove();
        $(".selection_sec_12_color").remove();

 $("#dropdown-wrapper_1").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_2").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_3").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_4").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_5").click(function (ev) {
          $(this).toggleClass("is-active");
        });

      $("#List_1 a").click(function (ev) {
        $("#selected_opt_1").html($(this).html());
        var addColor_1 = $(this)
          .children("#List_1 a span")
          .css("background-color");
        $("#selected_opt_1 span").css("background-color", addColor_1);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color1").val(getVal);
        $("#alert1").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_2 a").click(function (ev) {
        $("#selected_opt_2").html($(this).html());

        var addColor_2 = $(this)
          .children("#List_2 a span")
          .css("background-color");
        $("#selected_opt_2 span").css("background-color", addColor_2);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color2").val(getVal);
        $("#alert2").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_3 a").click(function (ev) {
        $("#selected_opt_3").html($(this).html());

        var addColor_3 = $(this)
          .children("#List_3 a span")
          .css("background-color");
        $("#selected_opt_3 span").css("background-color", addColor_3);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color3").val(getVal);
        $("#alert3").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_4 a").click(function (ev) {
        $("#selected_opt_4").html($(this).html());
        var addColor_4 = $(this)
          .children("#List_4 a span")
          .css("background-color");
        $("#selected_opt_4 span").css("background-color", addColor_4);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color4").val(getVal);
        $("#alert4").removeClass("alert");
        ev.preventDefault();
      });

        $("#List_5 a").click(function (ev) {
        $("#selected_opt_5").html($(this).html());
        var addColor_5 = $(this)
          .children("#List_5 a span")
          .css("background-color");
        $("#selected_opt_5 span").css("background-color", addColor_5);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color5").val(getVal);
        $("#alert5").removeClass("alert");
        ev.preventDefault();
      });
        
      } else if (
        product_handle.includes("ultimate-dip-set") ||
        product_handle.includes("sweet-dreams-dipping-kit") ||
        product_handle.includes("ultimate-8-week-challenge")
      ) {
        $(".selection_sec_1_color").remove();
        $(".selection_sec_4_color").remove();
        $(".selection_sec_5_color").remove();
        $(".selection_sec_10_color").remove();
        $(".selection_sec_12_color").remove();

        $("#dropdown-wrapper_1").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_2").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_3").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_4").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_5").click(function (ev) {
          $(this).toggleClass("is-active");
        });
         $("#dropdown-wrapper_6").click(function (ev) {
          $(this).toggleClass("is-active");
        });

 $("#List_1 a").click(function (ev) {
        $("#selected_opt_1").html($(this).html());
        var addColor_1 = $(this)
          .children("#List_1 a span")
          .css("background-color");
        $("#selected_opt_1 span").css("background-color", addColor_1);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color1").val(getVal);
        $("#alert1").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_2 a").click(function (ev) {
        $("#selected_opt_2").html($(this).html());

        var addColor_2 = $(this)
          .children("#List_2 a span")
          .css("background-color");
        $("#selected_opt_2 span").css("background-color", addColor_2);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color2").val(getVal);
        $("#alert2").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_3 a").click(function (ev) {
        $("#selected_opt_3").html($(this).html());

        var addColor_3 = $(this)
          .children("#List_3 a span")
          .css("background-color");
        $("#selected_opt_3 span").css("background-color", addColor_3);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color3").val(getVal);
        $("#alert3").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_4 a").click(function (ev) {
        $("#selected_opt_4").html($(this).html());
        var addColor_4 = $(this)
          .children("#List_4 a span")
          .css("background-color");
        $("#selected_opt_4 span").css("background-color", addColor_4);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color4").val(getVal);
        $("#alert4").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_5 a").click(function (ev) {
        $("#selected_opt_5").html($(this).html());
        var addColor_5 = $(this)
          .children("#List_5 a span")
          .css("background-color");
        $("#selected_opt_5 span").css("background-color", addColor_5);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color5").val(getVal);
        $("#alert5").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_6 a").click(function (ev) {
        $("#selected_opt_6").html($(this).html());
        var addColor_6 = $(this)
          .children("#List_6 a span")
          .css("background-color");
        $("#selected_opt_6 span").css("background-color", addColor_6);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color6").val(getVal);
        $("#alert6").removeClass("alert");
        ev.preventDefault();
      });
        
      } else if (product_handle.includes("10-dip-powder-bundle-you-choose") ||
                product_handle.includes("fully-stocked-set")) {
        $(".selection_sec_1_color").remove();
        $(".selection_sec_4_color").remove();
        $(".selection_sec_5_color").remove();
        $(".selection_sec_6_color").remove();
        $(".selection_sec_12_color").remove();

         $("#dropdown-wrapper_1").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_2").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_3").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_4").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_5").click(function (ev) {
          $(this).toggleClass("is-active");
        });
         $("#dropdown-wrapper_6").click(function (ev) {
          $(this).toggleClass("is-active");
        });
         $("#dropdown-wrapper_7").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_8").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_9").click(function (ev) {
          $(this).toggleClass("is-active");
        });
         $("#dropdown-wrapper_10").click(function (ev) {
          $(this).toggleClass("is-active");
        });

         $("#List_1 a").click(function (ev) {
        $("#selected_opt_1").html($(this).html());
        var addColor_1 = $(this)
          .children("#List_1 a span")
          .css("background-color");
        $("#selected_opt_1 span").css("background-color", addColor_1);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color1").val(getVal);
        $("#alert1").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_2 a").click(function (ev) {
        $("#selected_opt_2").html($(this).html());

        var addColor_2 = $(this)
          .children("#List_2 a span")
          .css("background-color");
        $("#selected_opt_2 span").css("background-color", addColor_2);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color2").val(getVal);
        $("#alert2").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_3 a").click(function (ev) {
        $("#selected_opt_3").html($(this).html());

        var addColor_3 = $(this)
          .children("#List_3 a span")
          .css("background-color");
        $("#selected_opt_3 span").css("background-color", addColor_3);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color3").val(getVal);
        $("#alert3").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_4 a").click(function (ev) {
        $("#selected_opt_4").html($(this).html());
        var addColor_4 = $(this)
          .children("#List_4 a span")
          .css("background-color");
        $("#selected_opt_4 span").css("background-color", addColor_4);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color4").val(getVal);
        $("#alert4").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_5 a").click(function (ev) {
        $("#selected_opt_5").html($(this).html());
        var addColor_5 = $(this)
          .children("#List_5 a span")
          .css("background-color");
        $("#selected_opt_5 span").css("background-color", addColor_5);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color5").val(getVal);
        $("#alert5").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_6 a").click(function (ev) {
        $("#selected_opt_6").html($(this).html());
        var addColor_6 = $(this)
          .children("#List_6 a span")
          .css("background-color");
        $("#selected_opt_6 span").css("background-color", addColor_6);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color6").val(getVal);
        $("#alert6").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_7 a").click(function (ev) {
        $("#selected_opt_7").html($(this).html());
        var addColor_7 = $(this)
          .children("#List_7 a span")
          .css("background-color");
        $("#selected_opt_7 span").css("background-color", addColor_7);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color7").val(getVal);
        $("#alert7").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_8 a").click(function (ev) {
        $("#selected_opt_8").html($(this).html());
        var addColor_8 = $(this)
          .children("#List_8 a span")
          .css("background-color");
        $("#selected_opt_8 span").css("background-color", addColor_8);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color8").val(getVal);
        $("#alert8").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_9 a").click(function (ev) {
        $("#selected_opt_9").html($(this).html());
        var addColor_9 = $(this)
          .children("#List_9 a span")
          .css("background-color");
        $("#selected_opt_9 span").css("background-color", addColor_9);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color9").val(getVal);
        $("#alert9").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_10 a").click(function (ev) {
        $("#selected_opt_10").html($(this).html());
        var addColor_10 = $(this)
          .children("#List_10 a span")
          .css("background-color");
        $("#selected_opt_10 span").css("background-color", addColor_10);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color10").val(getVal);
        $("#alert10").removeClass("alert");
        ev.preventDefault();
      });
        
      } else if (product_handle.includes("fully-stocked-set-old")) {
        $(".selection_sec_1_color").remove();
        $(".selection_sec_4_color").remove();
        $(".selection_sec_5_color").remove();
        $(".selection_sec_6_color").remove();
        $(".selection_sec_10_color").remove();

         $("#dropdown-wrapper_1").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_2").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_3").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_4").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_5").click(function (ev) {
          $(this).toggleClass("is-active");
        });
         $("#dropdown-wrapper_6").click(function (ev) {
          $(this).toggleClass("is-active");
        });
         $("#dropdown-wrapper_7").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_8").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_9").click(function (ev) {
          $(this).toggleClass("is-active");
        });
         $("#dropdown-wrapper_10").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        $("#dropdown-wrapper_11").click(function (ev) {
          $(this).toggleClass("is-active");
        });
         $("#dropdown-wrapper_12").click(function (ev) {
          $(this).toggleClass("is-active");
        });
        
         $("#List_1 a").click(function (ev) {
        $("#selected_opt_1").html($(this).html());
        var addColor_1 = $(this)
          .children("#List_1 a span")
          .css("background-color");
        $("#selected_opt_1 span").css("background-color", addColor_1);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color1").val(getVal);
        $("#alert1").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_2 a").click(function (ev) {
        $("#selected_opt_2").html($(this).html());

        var addColor_2 = $(this)
          .children("#List_2 a span")
          .css("background-color");
        $("#selected_opt_2 span").css("background-color", addColor_2);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color2").val(getVal);
        $("#alert2").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_3 a").click(function (ev) {
        $("#selected_opt_3").html($(this).html());

        var addColor_3 = $(this)
          .children("#List_3 a span")
          .css("background-color");
        $("#selected_opt_3 span").css("background-color", addColor_3);
        let getVal = $(this).text();
        // console.log(getVal);
        $("#color3").val(getVal);
        $("#alert3").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_4 a").click(function (ev) {
        $("#selected_opt_4").html($(this).html());
        var addColor_4 = $(this)
          .children("#List_4 a span")
          .css("background-color");
        $("#selected_opt_4 span").css("background-color", addColor_4);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color4").val(getVal);
        $("#alert4").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_5 a").click(function (ev) {
        $("#selected_opt_5").html($(this).html());
        var addColor_5 = $(this)
          .children("#List_5 a span")
          .css("background-color");
        $("#selected_opt_5 span").css("background-color", addColor_5);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color5").val(getVal);
        $("#alert5").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_6 a").click(function (ev) {
        $("#selected_opt_6").html($(this).html());
        var addColor_6 = $(this)
          .children("#List_6 a span")
          .css("background-color");
        $("#selected_opt_6 span").css("background-color", addColor_6);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color6").val(getVal);
        $("#alert6").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_7 a").click(function (ev) {
        $("#selected_opt_7").html($(this).html());
        var addColor_7 = $(this)
          .children("#List_7 a span")
          .css("background-color");
        $("#selected_opt_7 span").css("background-color", addColor_7);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color7").val(getVal);
        $("#alert7").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_8 a").click(function (ev) {
        $("#selected_opt_8").html($(this).html());
        var addColor_8 = $(this)
          .children("#List_8 a span")
          .css("background-color");
        $("#selected_opt_8 span").css("background-color", addColor_8);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color8").val(getVal);
        $("#alert8").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_9 a").click(function (ev) {
        $("#selected_opt_9").html($(this).html());
        var addColor_9 = $(this)
          .children("#List_9 a span")
          .css("background-color");
        $("#selected_opt_9 span").css("background-color", addColor_9);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color9").val(getVal);
        $("#alert9").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_10 a").click(function (ev) {
        $("#selected_opt_10").html($(this).html());
        var addColor_10 = $(this)
          .children("#List_10 a span")
          .css("background-color");
        $("#selected_opt_10 span").css("background-color", addColor_10);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color10").val(getVal);
        $("#alert10").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_11 a").click(function (ev) {
        $("#selected_opt_11").html($(this).html());
        var addColor_11 = $(this)
          .children("#List_11 a span")
          .css("background-color");
        $("#selected_opt_11 span").css("background-color", addColor_11);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color11").val(getVal);
        $("#alert11").removeClass("alert");
        ev.preventDefault();
      });
      $("#List_12 a").click(function (ev) {
        $("#selected_opt_12").html($(this).html());
        var addColor_12 = $(this)
          .children("#List_12 a span")
          .css("background-color");
        $("#selected_opt_12 span").css("background-color", addColor_12);
        let getVal = $(this).text();
        console.log(getVal);
        $("#color12").val(getVal);
        $("#alert12").removeClass("alert");
        ev.preventDefault();
      });
      } else {
        $(".selection_sec_1_color").remove();
        $(".selection_sec_4_color").remove();
        $(".selection_sec_5_color").remove();
        $(".selection_sec_6_color").remove();
        $(".selection_sec_10_color").remove();
        $(".selection_sec_12_color").remove();
      }
    });

    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = "";

      $("#quick-view select").each(function (i) {
        if (selectedOptions == "") {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + " / " + $(this).val();
        }
      });

      jQuery.getJSON("/products/" + product_handle + ".js", function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);

            var original_price = parseFloat(v.compare_at_price / 100).toFixed(
              2
            );

            var v_qty = v.inventory_quantity;

            var v_inv = v.inventory_management;

            $(".qv-product-price").text("$" + price);

            $(".qv-product-original-price").text("$" + original_price);

            if (v_inv == null) {
              $(".qv-add-button").prop("disabled", false).val("Add to Cart");
            } else {
              if (v.inventory_quantity < 1) {
                $(".qv-add-button").prop("disabled", true).val("Sold Out");
              } else {
                $(".qv-add-button").prop("disabled", false).val("Add to Cart");
              }
            }
          }
        });
      });
    });

    $.fancybox({
      href: "#quick-view",

      maxWidth: 1040,

      maxHeight: 600,

      fitToView: true,

      width: "75%",

      height: "70%",

      autoSize: false,

      closeClick: false,

      openEffect: "none",

      closeEffect: "none",

      beforeLoad: function () {
        var product_handle = $("#quick-view").attr("class");

        $(document).on("click", ".qv-add-button", function () {
          var qty = $(".qv-quantity").val();

          var selectedOptions = "";

          var var_id = "";

          var properties = {};

          $("#quick-view select").each(function (i) {
            if (selectedOptions == "") {
              selectedOptions = $(this).val();
            } else {
              selectedOptions = selectedOptions + " / " + $(this).val();
            }
          });

          jQuery.getJSON(
            "/products/" + product_handle + ".js",
            function (product) {
              $(product.variants).each(function (i, v) {
                if (v.title == selectedOptions) {
                  var_id = v.id;

                  processCart();
                }
              });
            }
          );

          function processCart() {
            if (validateColorsNew()) {
              jQuery
                .post(
                  "/cart/add.js",
                  {
                    quantity: qty,
                    id: var_id,
                    properties: properties,
                  },
                  null,
                  "json"
                )
                .done(function () {
                  $(".qv-add-to-cart-response")
                    .addClass("success")
                    .html(
                      "<span>" +
                        $(".qv-product-title").text() +
                        ' has been added to your cart. <a href="/cart">Click here to view your cart.</a>'
                        
                    );
                  
                  setTimeout(function(){$(".fancybox-close").trigger("click");}, 2000);

                  // console.log("test_count" , $('.js-drawer-open-button-right .cart-count').html());
                  var cart_count = $('.js-drawer-open-button-right .cart-count').html();
                  // eval(cart_count) + 1;
                  $('.js-drawer-open-button-right .cart-count').html(eval(cart_count) + 1);
                })
                .fail(function ($xhr) {
                  var data = $xhr.responseJSON;
                  $(".qv-add-to-cart-response")
                    .addClass("error")
                    .html("<span><b>ERROR: </b>" + data.description);
                });
            } else {
            }
          }

          // $('#subBtn').click(function(){
          function validateColorsNew() {
            var get_sec1 = $("#selected_opt_1").text();
            var get_sec2 = $("#selected_opt_2").text();
            var get_sec3 = $("#selected_opt_3").text();
            var get_sec4 = $("#selected_opt_4").text();
            var get_sec5 = $("#selected_opt_5").text();
            var get_sec6 = $("#selected_opt_6").text();
            var get_sec7 = $("#selected_opt_7").text();
            var get_sec8 = $("#selected_opt_8").text();
            var get_sec9 = $("#selected_opt_9").text();
            var get_sec10 = $("#selected_opt_10").text();
            var get_sec11 = $("#selected_opt_11").text();
            var get_sec12 = $("#selected_opt_12").text();

            console.log("data sec 1", get_sec1);
            var true_false = true;
            if (
              $("#selected_opt_1").text().trim() != "" &&
              $("#selected_opt_1").text().trim() == "Select Color"
            ) {
              $("#alert1").addClass("alert");
              true_false = false;
            } else {
              $("#alert1").removeClass("alert");
              properties.color1 = $("#selected_opt_1").text().trim();
            }

            if (
              $("#selected_opt_2").text().trim() != "" &&
              $("#selected_opt_2").text().trim() == "Select Color"
            ) {
              $("#alert2").addClass("alert");
              true_false = false;
            } else {
              $("#alert2").removeClass("alert");
              properties.color2 = $("#selected_opt_2").text().trim();
            }

            if (
              $("#selected_opt_3").text().trim() != "" &&
              $("#selected_opt_3").text().trim() == "Select Color"
            ) {
              $("#alert3").addClass("alert");
              true_false = false;
            } else {
              $("#alert3").removeClass("alert");
              properties.color3 = $("#selected_opt_3").text().trim();
            }

            if (
              $("#selected_opt_4").text().trim() != "" &&
              $("#selected_opt_4").text().trim() == "Select Color"
            ) {
              $("#alert4").addClass("alert");
              true_false = false;
            } else {
              $("#alert4").removeClass("alert");
              properties.color4 = $("#selected_opt_4").text().trim();
            }

            if (
              $("#selected_opt_5").text().trim() != "" &&
              $("#selected_opt_5").text().trim() == "Select Color"
            ) {
              $("#alert5").addClass("alert");
              true_false = false;
            } else {
              $("#alert5").removeClass("alert");
              properties.color5 = $("#selected_opt_5").text().trim();
            }

            if (
              $("#selected_opt_6").text().trim() != "" &&
              $("#selected_opt_6").text().trim() == "Select Color"
            ) {
              $("#alert6").addClass("alert");
              true_false = false;
            } else {
              $("#alert6").removeClass("alert");
              properties.color6 = $("#selected_opt_6").text().trim();
            }

            if (
              $("#selected_opt_7").text().trim() != "" &&
              $("#selected_opt_7").text().trim() == "Select Color"
            ) {
              $("#alert7").addClass("alert");
              true_false = false;
            } else {
              $("#alert7").removeClass("alert");
              properties.color7 = $("#selected_opt_7").text().trim();
            }

            if (
              $("#selected_opt_8").text().trim() != "" &&
              $("#selected_opt_8").text().trim() == "Select Color"
            ) {
              $("#alert8").addClass("alert");
              true_false = false;
            } else {
              $("#alert8").removeClass("alert");
              properties.color8 = $("#selected_opt_8").text().trim();
            }

            if (
              $("#selected_opt_9").text().trim() != "" &&
              $("#selected_opt_9").text().trim() == "Select Color"
            ) {
              $("#alert9").addClass("alert");
              true_false = false;
            } else {
              $("#alert9").removeClass("alert");
              properties.color9 = $("#selected_opt_9").text().trim();
            }

            if (
              $("#selected_opt_10").text().trim() != "" &&
              $("#selected_opt_10").text().trim() == "Select Color"
            ) {
              $("#alert10").addClass("alert");
              true_false = false;
            } else {
              $("#alert10").removeClass("alert");
              properties.color10 = $("#selected_opt_10").text().trim();
            }

            if (
              $("#selected_opt_11").text().trim() != "" &&
              $("#selected_opt_11").text().trim() == "Select Color"
            ) {
              $("#alert11").addClass("alert");
              true_false = false;
            } else {
              $("#alert11").removeClass("alert");
              properties.color11 = $("#selected_opt_11").text().trim();
            }

            if (
              $("#selected_opt_12").text().trim() != "" &&
              $("#selected_opt_12").text().trim() == "Select Color"
            ) {
              $("#alert12").addClass("alert");
              true_false = false;
            } else {
              $("#alert12").removeClass("alert");
              properties.color12 = $("#selected_opt_12").text().trim();
            }

            // if($('#selected_opt_1').text() == get_sec1 || (get_sec2!="" && $('#selected_opt_2').text() == get_sec2) || (get_sec3!="" && $('#selected_opt_3').text() == get_sec3) || (get_sec4!="" && $('#selected_opt_4').text() == get_sec4) || (get_sec5!="" && $('#selected_opt_5').text() == get_sec5) || (get_sec6!="" && $('#selected_opt_6').text() == get_sec6) || (get_sec7!="" && $('#selected_opt_7').text() == get_sec7) || (get_sec8!="" && $('#selected_opt_8').text() == get_sec8) || (get_sec9!="" && $('#selected_opt_9').text() == get_sec9) || (get_sec10!="" && $('#selected_opt_12').text() == get_sec10) || (get_sec11!="" && $('#selected_opt_11').text() == get_sec11) || (get_sec12!="" && $('#selected_opt_12').text() == get_sec12)){
            //     // $('#alert').addClass('alert');
            //   console.log("false");
            //     return false;
            // }else{
            //   console.log("true");
            //     return true;
            // }
            if (true_false) {
              // $('#alert').addClass('alert');
              console.log("true");
              return true;
            } else {
              console.log("false");
              return false;
            }
          }
        });

        $(".fancybox-wrap").css("overflow", "hidden !important");
      },

      afterShow: function () {
        $("#quick-view")
          .hide()
          .html(content)
          .css("opacity", "1")
          .fadeIn(function () {
            $(".qv-product-images").addClass("loaded");
          });
      },

      afterClose: function () {
        $("#quick-view").removeClass().empty();
      },
    });
  });
}

$(window).resize(function () {
  if ($("#quick-view").is(":visible")) {
    $(".qv-product-images").slick("setPosition");
  }
});
